var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-block"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.userInfo.username)}}),_c('a',{staticClass:"logout-btn",on:{"click":function (e) { return this$1.G.logout(this$1); }}},[_vm._v("退出登录")])])}
var staticRenderFns = []

export { render, staticRenderFns }